let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fk7Ii")).then(() => parcelRequire('77HKZ'));